import { render, staticRenderFns } from "./adoption_manuscript.vue?vue&type=template&id=631fd62a&scoped=true&"
import script from "./adoption_manuscript.vue?vue&type=script&lang=js&"
export * from "./adoption_manuscript.vue?vue&type=script&lang=js&"
import style0 from "./adoption_manuscript.vue?vue&type=style&index=0&id=631fd62a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631fd62a",
  null
  
)

export default component.exports